module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/logo-footer-c3af7050892f79a4c93cbfe47d4ac912.svg";